import { Component, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/core/authentication/auth.service';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss'],
  standalone: false
})
export class IndexComponent {
  private authService = inject(AuthService);
  translateService = inject(TranslateService);

  isAuthenticated: boolean = this.authService.isAuthenticated();
  showVideo: boolean = false;

  constructor() { }

  async signIn() {
    await this.authService.login();
  }
}
